/* eslint-disable */
import session from './session';

export default {
  getProviderAgentList(filter) {
    return session.get(`/api/v1/provider_agent/${filter}`);
  },
};
